import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'code-sent',
  templateUrl: './code-sent.component.html',
  styleUrls: ['./code-sent.component.css']
})
export class CodeSentComponent implements OnInit {

  public title: string;
  public message: string;

  constructor(protected dialogRef: NbDialogRef<CodeSentComponent>) {
    this.title = "";
    this.message = "";
   }

  ngOnInit(): void {
  }

  close(value: boolean){
    this.dialogRef.close(value);
  }

}
